import { SHOW_TOAST, GET_O, GET_O_S, GET_SL, GET_SLAVE_OPINION, GET_OPINIONID, FB_URL } from "./../actions/types";
import firebase from "../firebase";
import { _toArrayUsers, _toArrayUsersF, opinionsDatefix } from './commonActions'
import axios from 'axios';

// function makeid(length) {
//     var result           = '';
//     var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
//     var charactersLength = characters.length;
//       for ( var i = 0; i < length; i++ ) {
//         result += characters.charAt(Math.floor(Math.random() * 
//   charactersLength));
//     }
//     return result;
//   }

export const getOpinionsTrail = params => {
    return (dispatch, getState) => {
      firebase.database
        .ref('opinionsTrail')
        .orderByChild('leaderID')
        .equalTo(params.leaderID)
        .on('value', function (data) {
          if (data.val()) {
            let feedback = data.val()
            let receivedData = {}
            delete feedback.undefined
            // if (feedback.slaveID !== params.slaveID) {
            //   delete feedback.slaveID
            // }
            if (Object.keys(feedback).length > 0) {
              let sortedData = _toArrayUsersF(feedback, params.slaveID)
              sortedData.sort(function (a, b) {
              })
  
              receivedData = { ...sortedData }
  
              receivedData = Object.assign({}, sortedData)

             }
  
            dispatch({
              type: GET_SLAVE_OPINION,
              slaveopinion: receivedData
            })
          } else {
            dispatch({
              type: GET_SLAVE_OPINION,
              slaveopinion: {}
            })
          }
        })
    }
  }

  export const addSOpinion = params => {
    let database = firebase.database;
    const updates = {};
   // const opinionID = makeid(10);
    var addOpinion = true;
   //////////////////////////////////////////////////////

    return (dispatch, getState) => {
        updates['/opinionsTrail/' + params.opinionID ] = { 
            opinionID: params.opinionID,
            leaderID: params.leaderID,
            slaveID: params.slaveID,
            companyName: params.companyName,
            companyID: params.companyID,
            firstName: params.firstName,
            lastName: params.lastName,
            slave: params.slave,
            simpleopinion: params.simpleopinion,
            simple: params.simple,
            sdate: params.sdate,
            type: params.type
           };

        // updates['/opinionsTrail/' + params.opinionID + '/simpleopinion'] = params.simpleopinion;
        // updates['/opinionsTrail/' + params.opinionID + '/simple'] = params.simple;
           database
            .ref()
            .update(updates)
            .then(() => {
               dispatch({
                type: SHOW_TOAST,
                variant: "success",
                message: "Thank you for your feedback.",
                pos: "bottom"
              });
            })
            .catch(err => {
              dispatch({
                type: "SHOW_TOAST",
                open: true,
                variant: "error",
                message: "Error response: " + err.message
              });
              })    
           }
      }

  //WHATSTEPP SEND////////////////////////////////////////////////////////////////
  const sendWhatsAppMessage = async(phoneNumber, message) => {
    try {
      const res = await axios.post(`${FB_URL}/m109-whatsappsend`, {
        params: {
         to: phoneNumber, // recipient's phone number in international format
         message: message, // message content
         contentID: "HXa2decba5e6171a995332b4a0df3d559d" //template for thinklead
         //contentID: "HXef0df86280f638ab5c93d05ee378c84c" //template for harmony
        }
      });
    } catch (error) {

    }
  }

  //WHATSAPP LOGIN SECURITY NOTIFICATION////////////////////////////////////////
  export const sendWhatsAppLoginNotification = async(userID) => {
    try {
      // Get user's cellphone and WhatsApp preference
      const userRef = firebase.database.ref(`users/${userID}`);
      const snapshot = await userRef.once('value');
      
      if (snapshot.exists()) {
        const userData = snapshot.val();
        const cellphone = userData.cellphone;
        const receiveWhatsAppSecurity = userData.receiveWhatsAppSecurity;
        
        // Only send if user has opted in for WhatsApp security notifications
        if (receiveWhatsAppSecurity && cellphone) {
          const currentTime = new Date().toLocaleString();
          const message = `🔐 Security Alert!\n\nYour ThinkLead account was just accessed.\n\nTime: ${currentTime}\n\nIf this wasn't you, please secure your account immediately.\n\nStay safe!\n- ThinkLead Security Team`;
          
          await sendWhatsAppMessage(cellphone, message);
        }
      }
    } catch (error) {

    }
  }

  //WHATSAPP OTP AUTHENTICATION//////////////////////////////////////////////////
  // Generate 6-digit OTP
  const generateOTP = () => {
    return Math.floor(100000 + Math.random() * 900000).toString();
  }

  // Send WhatsApp OTP with custom message
  const sendWhatsAppOTPMessage = async(phoneNumber, message) => {
    try {
      // Try approach 1: No contentID (custom message)
      let res = await axios.post(`${FB_URL}/m109-whatsappsend`, {
        params: {
         to: phoneNumber,
         message: message
        }
      });
      
      // If that doesn't work, try approach 2: Different contentID for OTP
      res = await axios.post(`${FB_URL}/m109-whatsappsend`, {
        params: {
         to: phoneNumber,
         message: message,
         contentID: "HXef0df86280f638ab5c93d05ee378c84c" // Different template ID
        }
      });
      
      // Try approach 3: Different endpoint for OTP
      try {
        res = await axios.post(`${FB_URL}/m110-whatsappotp`, {
          params: {
           to: phoneNumber,
           message: message,
           otp: true // Flag to indicate this is an OTP message
          }
        });
      } catch (otpEndpointError) {
        // OTP endpoint not available, continue with other approaches
      }
      
    } catch (error) {

    }
  }

  // Send WhatsApp OTP
  export const sendWhatsAppOTP = async(userID) => {
    try {
      // Get user's cellphone and WhatsApp preference
      let userRef = firebase.database.ref(`users/${userID}`);
      let snapshot = await userRef.once('value');
      let userData = null;
      
      if (!snapshot.exists()) {
        // Try the user table instead
        userRef = firebase.database.ref(`user`);
        const allUsers = await userRef.once('value');
        
        if (allUsers.exists()) {
          const users = allUsers.val();
          // Find user by userID
          for (let uid in users) {
            if (users[uid].userID === userID) {
              userData = users[uid];
              break;
            }
          }
        }
      } else {
        userData = snapshot.val();
      }
      
      if (userData) {
        const cellphone = userData.cellphone;
        const receiveWhatsAppSecurity = userData.receiveWhatsAppSecurity;
        
        // Only send if user has opted in for WhatsApp security
        if (receiveWhatsAppSecurity && cellphone) {
          const otp = generateOTP();
          const expiryTime = Date.now() + (5 * 60 * 1000); // 5 minutes expiry
          
          // Store OTP in database with expiry
          const otpRef = firebase.database.ref(`userOTP/${userID}`);
          await otpRef.set({
            otp: otp,
            expiryTime: expiryTime,
            verified: false,
            createdAt: Date.now()
          });
          
          const message = `🔐 ThinkLead Security Code\n\nYour login verification code is: ${otp}\n\nThis code expires in 5 minutes.\n\nDo not share this code with anyone.\n\n- ThinkLead Security Team`;
          
          await sendWhatsAppOTPMessage(cellphone, message);
          
          return { success: true, message: 'OTP sent successfully' };
        } else {
          return { success: false, message: 'WhatsApp security not enabled or no phone number' };
        }
      } else {
        return { success: false, message: 'User not found' };
      }
    } catch (error) {

      return { success: false, message: 'Error sending OTP' };
    }
  }

  // Verify WhatsApp OTP
  export const verifyWhatsAppOTP = async(userID, enteredOTP) => {
    try {
      const otpRef = firebase.database.ref(`userOTP/${userID}`);
      const snapshot = await otpRef.once('value');
      
      if (snapshot.exists()) {
        const otpData = snapshot.val();
        const currentTime = Date.now();
        
        // Check if OTP is expired
        if (currentTime > otpData.expiryTime) {
          await otpRef.remove(); // Clean up expired OTP
          return { success: false, message: 'OTP has expired. Please request a new one.' };
        }
        
        // Check if OTP matches
        if (otpData.otp === enteredOTP && !otpData.verified) {
          // Mark OTP as verified
          await otpRef.update({ verified: true });
          
          // Clean up OTP after successful verification
          setTimeout(async () => {
            await otpRef.remove();
          }, 1000);
          
          return { success: true, message: 'OTP verified successfully' };
        } else {
          return { success: false, message: 'Invalid OTP. Please try again.' };
        }
      } else {
        return { success: false, message: 'No OTP found. Please request a new one.' };
      }
    } catch (error) {

      return { success: false, message: 'Error verifying OTP' };
    }
  }

  // Check if user needs WhatsApp OTP
  export const checkWhatsAppOTPRequired = async(userID) => {
    try {
      // Try both possible database locations
      let userRef = firebase.database.ref(`users/${userID}`);
      let snapshot = await userRef.once('value');
      
      if (!snapshot.exists()) {
        // Try the user table instead
        userRef = firebase.database.ref(`user`);
        const allUsers = await userRef.once('value');
        
        if (allUsers.exists()) {
          const users = allUsers.val();
          // Find user by userID
          for (let uid in users) {
            if (users[uid].userID === userID) {
              const userData = users[uid];
              return userData.receiveWhatsAppSecurity && userData.cellphone;
            }
          }
        }
      } else {
        const userData = snapshot.val();
        return userData.receiveWhatsAppSecurity && userData.cellphone;
      }
      
      return false;
    } catch (error) {

      return false;
    }
  }

  async function getUserCellphone(userID) {
    let db = firebase.database;
    try {
      // Reference to the user table and specific user
      const userRef = db.ref(`users/${userID}/cellphone`);
      
      // Fetch cellphone field
      const snapshot = await userRef.once('value');
      
      if (snapshot.exists()) {
        return snapshot.val();
      } else {

        return null;
      }
    } catch (error) {

      throw error;
    }
  }

      export const addOpinions_ledain = params => {
        let database = firebase.database;
        const updates = {};
       // const opinionID = makeid(10);
        var addOpinion = true;
       ///////////////////////////////////////


        return async(dispatch, getState) => {
            updates['/opinionsTrail/' + params.opinionID ] = { 
                opinionID: params.opinionID,
                leaderID: params.leaderID,
                slaveID: params.slaveID,
                companyName: params.companyName,
                companyID: params.companyID,
                firstName: params.firstName,
                lastName: params.lastName,
                slave: params.slave,
                valueA: params.valueA,
                valueAopinion: params.valueAopinion,
                valueB: params.valueB,
                valueBopinion: params.valueBopinion,
                valueC: params.valueC,
                valueCopinion: params.valueCopinion,
                valueD: params.valueD,
                valueDopinion: params.valueDopinion,
                valueE: params.valueE,
                valueEopinion: params.valueEopinion,
                valueF: params.valueF,
                valueFopinion: params.valueFopinion,
                valueG: params.valueG,
                valueGopinion: params.valueGopinion,
                valueH: params.valueH,
                valueHopinion: params.valueHopinion,
                type: params.type,

                simple: params.simple ? params.simple : 0,
                simpleopinion: params.simpleopinion ? params.simpleopinion : '',
                sdate: params.sdate
               };
              //  database
              //   .ref()
              //   .update(updates)
              //   .then(() => {
              //      dispatch({
              //       type: SHOW_TOAST,
              //       variant: "success",
              //       message: "Thank you for your feedback.",
              //       pos: "bottom"
              //     });
              //     //SEND WHATSAPP NOTIFICATION
              //     getUserCellphone(params.leaderID)
              //     .then((telephone) => {
              //       const message = `New Feedback Alert!\n \n You've just received fresh, real-time feedback on LeaderTrack!\n \n Check it out now: https://harmony.thinklead.co.za/ \n \n - Dive into your Personal Development Plan, then click on LeaderTrack and find the latest insights waiting for you, tagged by date and time.\n \n Embrace the growth!
              //       `;                   
              //       const cellnr = telephone;
              //       if (telephone) {
              //         sendWhatsAppMessage(cellnr, message);
              //         //sendOTP(cellnr, message);
              //       } 
              //     })
              //     .catch((error) => {

              //     });

              //   })
              var res = await axios.post(`${FB_URL}/m115-freshcard`, {
                params: {
                    updates: updates, //user wallet address                       
                  }
                })
  
                if (res.data || res.data.success === true) {
                  dispatch({
                    type: "SHOW_TOAST",
                    open: true,
                    variant: "success",
                    message: "Survey done successfully:"
                  });
                }
                else {
                  dispatch({
                    type: "SHOW_TOAST",
                    open: true,
                    variant: "error",
                    message: "Error in addOpinions_ledain function"
                  });
                }; 
                // .catch(err => {
                //   dispatch({
                //     type: "SHOW_TOAST",
                //     open: true,
                //     variant: "error",
                //     message: "Error response: " + err.message
                //   });
                //   })    
               }
          }

    export const addOpinions = params => {
       let database = firebase.database;
            const updates = {};
           // const opinionID = makeid(10);
            var addOpinion = true;
           ///////////////////////////////////////

            return (dispatch, getState) => {
                updates['/opinionsTrail/' + params.opinionID ] = { 
                    opinionID: params.opinionID,
                    leaderID: params.leaderID,
                    slaveID: params.slaveID,
                    companyName: params.companyName,
                    companyID: params.companyID,
                    firstName: params.firstName,
                    lastName: params.lastName,
                    slave: params.slave,
                    valueA: params.valueA,
                    valueAopinion: params.valueAopinion,
                    valueB: params.valueB,
                    valueBopinion: params.valueBopinion,
                    valueC: params.valueC,
                    valueCopinion: params.valueCopinion,
                    valueD: params.valueD,
                    valueDopinion: params.valueDopinion,
                    valueE: params.valueE,
                    valueEopinion: params.valueEopinion,
                    valueF: params.valueF,
                    valueFopinion: params.valueFopinion,
                    valueG: params.valueG,
                    valueGopinion: params.valueGopinion,
                    valueH: params.valueH,
                    valueHopinion: params.valueHopinion,
                    type: params.type
                    // simple: params.simple ? params.simple : 0,
                    // simpleopinion: params.simpleopinion ? params.simpleopinion : ''
                   };
                   database
                    .ref()
                    .update(updates)
                    .then(() => {
                       dispatch({
                        type: SHOW_TOAST,
                        variant: "success",
                        message: "Thank you for your feedback.",
                        pos: "bottom"
                      });
                    })
                    .catch(err => {
                      dispatch({
                        type: "SHOW_TOAST",
                        open: true,
                        variant: "error",
                        message: "Error response: " + err.message
                      });
                      })    
                   }
              }

// export const addOpinions_31Aug = params => {
//     let database = firebase.database;
//     const updates = {};
//    // const opinionID = makeid(10);
//     var addOpinion = true;
//    ///////////////////////////////////////
//     return (dispatch, getState) => {
//         updates['/opinionsTrail/' + params.opinionID ] = { 
//             opinionID: params.opinionID,
//             leaderID: params.leaderID,
//             slaveID: params.slaveID,
//             companyName: params.companyName,
//             companyID: params.companyID,
//             firstName: params.firstName,
//             lastName: params.lastName,
//             slave: params.slave,
//             self: params.self,
//             selfopinion: params.selfopinion,
//             others: params.others,
//             othersopinion: params.othersopinion,
//             organisation: params.organisation,
//             orgopinion: params.orgopinion,
//             society: params.society,
//             sosopinion: params.sosopinion,
//             simple: params.simple ? params.simple : 0,
//             simpleopinion: params.simpleopinion ? params.simpleopinion : ''
//            };
//            database
//             .ref()
//             .update(updates)
//             .then(() => {
//                dispatch({
//                 type: SHOW_TOAST,
//                 variant: "success",
//                 message: "Thank you for your feedback.",
//                 pos: "bottom"
//               });
//             })
//             .catch(err => {
//               dispatch({
//                 type: "SHOW_TOAST",
//                 open: true,
//                 variant: "error",
//                 message: "Error response: " + err.message
//               });
//               })    
//            }
//       }
 
      const getSlaveID = (props) => {
        for (let x in props) {
          return props[x].slaveID
        }
       }

       export const xfindSlave = (leaderID, slaveID) => {
         var pass = true;
         var database = firebase.database;
                 database
                  .ref('opinionsTrail')
                  .orderByChild('leaderID')
                  .equalTo(leaderID)
                  .on('value', function (data) {  
                    if (data.val()) {
                      let odata = data.val() 
                      if (Object.keys(odata).length > 0) {
                       let sortedData = _toArrayUsers(odata)
                       Object.keys(sortedData).map((id, index) => {
 
                     if (sortedData[id].leaderID===leaderID) {
                       if (sortedData[id].slaveID===slaveID) { //user already made opinion on this leader

                        pass = false;
                        return pass;
                       }
                     }
                   }) }} })}

    export const deleteSlave = params => {
        return (dispatch, getState) => {
        var database = firebase.database;
                database
                 .ref('opinionsTrail')
                 .orderByChild('leaderID')
                 .equalTo(params.leaderID)
                 .on('value', function (data) {  
                   if (data.val()) {
                     let odata = data.val() 
                     if (Object.keys(odata).length > 0) {
                      let sortedData = _toArrayUsers(odata)
                      Object.keys(sortedData).map((id, index) => {


                   // if (sortedData[id].opinionID === params.opinionID) {} else {
                      if (sortedData[id].slaveID===params.slaveID) { //user already made opinion

                        database.ref(`opinionsTrail/${sortedData[id].opinionID}`).remove()
                      }
                    //}
                  }) }} })}}

 export const getOpinions = params => {
     if (params && params.leaderID) {
       return (dispatch, getState) => {
         firebase.database
           .ref('opinionsTrail')
           .orderByChild('leaderID')
           .equalTo(params.leaderID)
           .on('value', function (data) {    
             if (data.val()) {
               let odata = data.val()
               let receivedData = {}
               delete odata.undefined
               if (Object.keys(odata).length > 0) {

                 let sortedData = opinionsDatefix(odata)
                 //let sortedData = _toArrayUsers(odata)
                 //let sortedData = _toArrayUsersF(odata, params.slaveID)
 
                 sortedData.sort(function (a, b) {
     
                   if (a.sdate > b.sdate) {
                     return -1
                   }
                   if (a.sdate < b.sdate) {
                     return 1
                   }
                   return 0
                 })
     
                 receivedData = { ...sortedData }
     
                 receivedData = Object.assign({}, sortedData)
                }
     
              dispatch({
                 type: GET_O,
                 opinion: receivedData 
               })
             } else {
               dispatch({
                 type: GET_O,
                 opinion: {}
               })
             }
           })
       }
      } else {
        // Return a valid action when leaderID is missing
        return (dispatch, getState) => {
          dispatch({
            type: GET_O,
            opinion: {}
          })
        }
      }
     }

      export const getOpinions_pSlave = params => {

            if (params && params.slaveID) {
              return (dispatch, getState) => {
                firebase.database
                  .ref('opinionsTrail')
                  .orderByChild('slaveID')
                  .equalTo(params.slaveID)
                  .on('value', function (data) {    

                    if (data.val()) {
                      let odata = data.val()
                      let receivedData = {}
                      delete odata.undefined
                      if (Object.keys(odata).length > 0) {
      

      
                        let sortedData = opinionsDatefix(odata)
                        //let sortedData = _toArrayUsers(odata)
                        //let sortedData = _toArrayUsersF(odata, params.slaveID)


                        sortedData.sort(function (a, b) {
            
                          if (a.sdate > b.sdate) {
                            return -1
                          }
                          if (a.sdate < b.sdate) {
                            return 1
                          }
                          return 0
                        })
            
                        receivedData = { ...sortedData }
            
                        receivedData = Object.assign({}, sortedData)
                       }

                     dispatch({
                        type: GET_SL,
                        opinion_sl: receivedData 
                      })
                    } else {
                      dispatch({
                        type: GET_SL,
                        opinion_sl: {}
                      })
                    }
                  })
              }
             } else {
              // Return a valid action when slaveID is missing
              return (dispatch, getState) => {
                dispatch({
                  type: GET_SL,
                  opinion_sl: {}
                })
              }
             }
            }

      export const getOpinionsOnSubmit = params => {
        if (params && params.leaderID) {
          return (dispatch, getState) => {
              firebase.database
              .ref('opinionsTrail')
              .orderByChild('leaderID')
              .equalTo(params.leaderID)
              .on('value', function (data) {    
                if (data.val()) {
                  let odata = data.val()
                  let receivedData = {}
                  delete odata.undefined
                  if (Object.keys(odata).length > 0) {
  
                    //let sortedData = _toArrayUsers(odata)
                    let sortedData = _toArrayUsersF(odata, params.slaveID)

    
                    sortedData.sort(function (a, b) {
        
                      if (a.firstName > b.firstName) {
                        return 1
                      }
                      if (a.firstName < b.firstName) {
                        return -1
                      }
                      return 0
                    })
        
                    receivedData = { ...sortedData }
        
                    receivedData = Object.assign({}, sortedData)

                   }
        
                  dispatch({
                    type: GET_O_S,
                    sopinion: receivedData
                  })
                } else {
                  dispatch({
                    type: GET_O_S,
                    sopinion: {}
                  })
                }
              })
          }
         } else {
          // Return a valid action when leaderID is missing
          return (dispatch, getState) => {
            dispatch({
              type: GET_O_S,
              sopinion: {}
            })
          }
         }
        }

        export const FindSlave = params => {
          if (params && params.leaderID) {
            var opinionIDfinal = '';
             return (dispatch, getState) => {
              firebase.database
                .ref('opinionsTrail')
                .orderByChild('leaderID')
                .equalTo(params.leaderID)
                .on('value', function (data) {    
                  if (data.val()) {
                    let odata = data.val()
                    let receivedData = {}
                    delete odata.undefined
                    if (Object.keys(odata).length > 0) {


                     // let sortedData = _toArrayUsers(odata)
                      let sortedData = _toArrayUsersF(odata, params.slaveID)

      
                      sortedData.sort(function (a, b) {
          
                        if (a.firstName > b.firstName) {
                          return 1
                        }
                        if (a.firstName < b.firstName) {
                          return -1
                        }
                        return 0
                      })
          
                      receivedData = { ...sortedData }
          
                      receivedData = Object.assign({}, sortedData)
                      if (receivedData && receivedData[0] && receivedData[0].opinionID) {

                        opinionIDfinal = receivedData[0].opinionID
                      }
                      else
                      {
                        opinionIDfinal = ''
                      }
                     }
          
                    dispatch({
                      type: GET_OPINIONID,
                      opinion: opinionIDfinal
                    })
                  } else {
                    dispatch({
                      type: GET_OPINIONID,
                      opinion: ''
                    })
                  }
                })
            }
           } else {
            // Return a valid action when leaderID is missing
            return (dispatch, getState) => {
              dispatch({
                type: GET_OPINIONID,
                opinion: ''
              })
            }
           }
          }

  //  export const FindSlave = params => {
  //       return (dispatch, getState) => {
  //       var pass = ''; //no post yet
  //       var database = firebase.database;
  //       database
  //         .ref('opinionsTrail')
  //         .orderByChild('leaderID')
  //         .equalTo(params.leaderID)
  //         .on('value', function (data) {
    
  //           if (data.val()) {
  //             let odata = data.val()
  //             if (Object.keys(odata).length > 0) {
  //               let sortedData = _toArrayUsers(odata)
  //               Object.keys(sortedData).map((id, index) => {
    
  //                 if (sortedData[id].leaderID === params.leaderID) {
  //                   if (sortedData[id].slaveID === params.slaveID) { //user already made opinion on this leader
  //                    pass = sortedData[id].opinionID; //has posted before
  //                     if (pass) {
  //                     dispatch({
  //                       type: GET_OPINIONID,
  //                       opinion: pass
  //                     })
  //                   } else {
  //                     dispatch({
  //                       type: GET_OPINIONID,
  //                       opinion: {}
  //                     })
  //                   }
  //                   }
  //                 }
  //               })
  //             }
  //           }
  //         })
  //       }
  //     }